module.exports = __webpack_public_path__ + "img/scene4.44098bf7.webp";